<template>
  <svg
    class="dropdown-icon"
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.22917 4.19875e-05C7.37976 -0.00100523 7.52723 0.042241 7.65257 0.124211C7.77792 0.206182 7.8754 0.323122 7.93247 0.459972C7.99449 0.595883 8.01439 0.746716 7.98969 0.893658C7.96498 1.0406 7.89677 1.17715 7.79355 1.28628L4.56433 4.75432C4.49308 4.83168 4.4061 4.89351 4.30902 4.93582C4.21193 4.97814 4.10689 5 4.00067 5C3.89445 5 3.78941 4.97814 3.69233 4.93582C3.59524 4.89351 3.50827 4.83168 3.43701 4.75432L0.207788 1.28628C0.104296 1.17733 0.0357342 1.0409 0.0106447 0.893968C-0.0144448 0.747036 0.00504689 0.596103 0.0666916 0.459972C0.123475 0.322779 0.220992 0.205542 0.346555 0.123514C0.472119 0.0414854 0.619916 -0.00153762 0.77072 4.19875e-05H7.22917Z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'DropdownIcon',
}
</script>
